import { TileLayer } from "react-leaflet";
import {
  SALONPAGE_MAP_TILE_MAX_NATIVE_ZOOM,
  SALONPAGE_MAP_TILE_URL,
} from "./_map-tiles";

export function SalonpageTileLayer() {
  return (
    <TileLayer
      url={SALONPAGE_MAP_TILE_URL}
      maxNativeZoom={SALONPAGE_MAP_TILE_MAX_NATIVE_ZOOM}
    />
  );
}
